<template>
  <div>
    <DxDataGrid
        :show-row-lines="true"
        :show-column-lines="true"
        :show-borders="true"
        :row-alternation-enabled="true"
        :rtl-enabled="label.direction === 'rtl' ? true : false"
        :data-source="sliders"
        :columns="sliderFields"
        :remote-operations="true"
        :column-auto-width="true"
        :allow-column-reordering="true"
        :allow-column-resizing="true"
        column-resizing-mode="widget"
        :hover-state-enabled="true"
        :noDataText="checkData"
        @toolbar-preparing="onToolbarPreparing($event)"
        key-expr="id"
        class="ps_Table"
        :height="dataGridHeight-70"
    >
      <DxSearchPanel
          :visible="true"
          :width="240"
          :placeholder="label.table.search"
      />
      <template #btnRGroup>
        <b-row class="btnRLanguage-wrapper" v-show="contentLanguageAccess == 1">
          <b-col cols="auto">
            <label for="language" class="ps_label">
              {{label.pages.contentLanguage}}
            </label>
          </b-col>
          <b-col >
            <v-select
                input-id="language"
                :options="languages"
                v-model="selectedLanguage"
                :reduce="group => group.id"
                :clearable="false"
                size="sm"
                class="ps_select"
                @input="setLanguage"
            >
            </v-select>
          </b-col>
        </b-row>
      </template>
      <template #btnGroup>
        <div>
          <b-row>
            <b-col cols="auto" class="px-1">
              <b-button
                  variant="ps-success"
                  class="py-1 pb-2"
                  size="sm"
                  v-b-tooltip.hover
                  :title="label.buttons.newSlider"
                  @click="add"
              >
                <b-icon icon="plus" scale="2" color="#fff"></b-icon>
              </b-button>
            </b-col>
            <b-col cols="auto" class="px-1">
              <b-button
                  variant="ps-secondary"
                  class="py-1 pb-2"
                  size="sm"
                  v-b-tooltip.hover
                  :title="label.table.reload"
                  @click="reloadContent"
              >
                <b-icon icon="arrow-repeat" scale="1.5" color="#fff"></b-icon>
              </b-button>
            </b-col>
          </b-row>
        </div>
      </template>
      <template #radif="{data}">
        <div>
          {{ data.rowIndex + 1 }}
        </div>
      </template>
      <template #image="{data}">
        <div>
          <img :src="data.data.imageAddress" class="ps_table_inside_img"/>
        </div>
      </template>
      <template #actions="{data}">
        <b-row class="justify-content-center">
          <b-col cols="auto" class="px-0">
            <button
                @click="edit(data)"
                :id="'editBtnTlp-' + data.data.id"
            >
              <b-icon icon="dash-square-fill" scale="1.1" variant="ps-edit-icon"></b-icon>
            </button>
            <b-tooltip
              boundary="#app"
              noninteractive
              triggers="hover"
              :target="'editBtnTlp-' + data.data.id"
            >
              {{ label.buttons.edit }}
            </b-tooltip>
          </b-col>
          <b-col cols="auto" class="px-0 pe-2">
            <button
                @click="del(data)"
                :id="'deleteBtnTlp-' + data.data.id"
            >
              <b-icon icon="x-square-fill" scale="1.1" variant="ps-delete-icon"></b-icon>
            </button>
            <b-tooltip
              boundary="#app"
              noninteractive
              triggers="hover"
              :target="'deleteBtnTlp-' + data.data.id"
            >
              {{ label.buttons.delete }}
            </b-tooltip>
          </b-col>
        </b-row>
      </template>
      <DxLoadPanel :enabled="true"/>
      <DxScrolling mode="virtual"/>
    </DxDataGrid>


    <!--  Add Slider Modal -->
    <b-modal
        :dir="label.direction"
        v-model="addSliderModal"
        header-bg-variant="ps-success"
        centered
    >
      <template #modal-header>
        <h4 class="text-white fw1">
          {{label.pages.newSlider}}
        </h4>
        <button
            class="ps-closeModalBtn"
            @click="addSliderModal=false"
            id="closeAddModalTlp"
        >
          <b-icon icon="x-square"></b-icon>
        </button>
        <b-tooltip
          boundary="#app"
          noninteractive
          triggers="hover"
          target="closeAddModalTlp"
        >
          {{ label.buttons.closeModal }}
        </b-tooltip>
      </template>
      <b-container fluid>
        <b-row class="mb-3 mt-1" v-show="contentLanguageAccess == 1">
          <b-col sm="3">
            <label for="AddContentLanguage" class="ps_label">
              {{label.pages.contentLanguage}}
            </label>
          </b-col>
          <b-col sm="9">
            <v-select
                input-id="AddContentLanguage"
                :options="languages"
                v-model="selectedLanguage"
                :reduce="group => group.id"
                :clearable="false"
                size="sm"
                class="ps_select"
                disabled
            >
            </v-select>
          </b-col>
        </b-row>
        <b-row class="my-3">
          <b-col sm="3">
            <label for="bannerTitle" class="ps_label">{{label.pages.title}}</label>
          </b-col>
          <b-col sm="9">
            <b-form-input id="bannerTitle" size="sm" v-model="form.title"/>
          </b-col>
        </b-row>
        <b-row class="my-3">
          <b-col sm="3">
            <label for="bannerLink" class="ps_label">{{label.pages.description}}</label>
          </b-col>
          <b-col sm="9">
            <b-form-textarea id="bannerLink" size="sm" v-model="form.description"/>
          </b-col>
        </b-row>
        <b-row class="my-3">
          <b-col sm="3">
            <label for="sliderLink" class="ps_label">{{label.pages.linkSlider}}</label>
          </b-col>
          <b-col sm="9">
            <b-form-input id="sliderLink" dir="ltr" size="sm" v-model="form.link"/>
          </b-col>
        </b-row>
        <b-row class="my-3">
          <b-col sm="3">
            <label for="priority" class="ps_label">{{label.pages.priority}}</label>
          </b-col>
          <b-col sm="9">
            <b-form-input id="priority" size="sm" type="number" v-model="form.priority"/>
          </b-col>
        </b-row>
        <b-row class="my-3">
          <b-col sm="3">
            <label for="timeShow" class="ps_label">
              {{label.pages.timeShow}}
            </label>
          </b-col>
          <b-col sm="9">
            <date-picker
                v-model="form.range"
                range
                clearable
                color="#6AA435"
                :min="time"
                display-format="jYYYY/jMM/jDD"
            />
          </b-col>
        </b-row>
        <b-row v-if="dropZoneAction" class="my-3">
          <b-col sm="3">
            <label for="image" class="ps_label">{{label.pages.photo}}</label><span class="ps_label_star">*</span>
          </b-col>
          <b-col sm="auto">
            <drop-zone-custom
                mode="image"
                :isRequired="true"
                :add="dropZoneAction"
                :edit="!dropZoneAction"
                :editSrc="form.imageAddress"
            />
          </b-col>
        </b-row>
        <b-row v-if="!dropZoneAction" class="my-3">
          <b-col sm="12">
            <drop-zone-custom
                mode="image"
                :isRequired="true"
                :add="dropZoneAction"
                :edit="!dropZoneAction"
                :editSrc="form.imageAddress"
            />
          </b-col>
        </b-row>
        <b-row class="my-3">
          <b-col sm="3">
            <label for="bannerDisplay" class="ps_label">
              {{label.form.display}}
            </label>
          </b-col>
          <b-col sm="9">
            <label class="ps-switch">
              <input type="checkbox" v-model="form.isConfirm">
              <span class="slider round"></span>
            </label>
          </b-col>
        </b-row>
      </b-container>
      <template #modal-footer>
        <b-row class="w-100 justify-content-end">
          <b-col cols="auto" class="px-0">
            <b-button
                variant="ps-secondary"
                size="sm"
                class="mx-1"
                @click="addSliderModal=false"
            >
            {{label.buttons.cancel}}
            </b-button>
          </b-col>
          <b-col cols="auto" class="px-0">
            <b-button
                v-if="!loadingBtn"
                variant="ps-success"
                size="sm"
                class="mx-1"
                @click="addSlider"
            >
            {{label.buttons.submit}}
            </b-button>
            <b-button
                v-else
                variant="ps-success"
                size="sm"
                class="mx-1"
                disabled
            >
              <b-spinner small></b-spinner>
            </b-button>
          </b-col>
        </b-row>
      </template>
    </b-modal>


    <!-- edit Banner Modal -->
    <b-modal
        :dir="label.direction"
        v-model="editSliderModal"
        header-bg-variant="ps-warning"
        centered
    >
      <template #modal-header>
        <h4 class="text-white fw1">
          {{label.pages.editSlider}}
        </h4>
        <button
            class="ps-closeModalBtn"
            @click="editSliderModal=false"
            id="closeEditModalTlp"
        >
          <b-icon icon="x-square"></b-icon>
        </button>
        <b-tooltip
          boundary="#app"
          noninteractive
          triggers="hover"
          target="closeEditModalTlp"
        >
          {{ label.buttons.closeModal }}
        </b-tooltip>
      </template>
      <b-container fluid>
        <b-row class="mb-3 mt-1" v-show="contentLanguageAccess == 1">
          <b-col sm="3">
            <label for="AddContentLanguage" class="ps_label">
              {{label.pages.contentLanguage}}
            </label>
          </b-col>
          <b-col sm="9">
            <v-select
                input-id="AddContentLanguage"
                :options="languages"
                v-model="selectedLanguage"
                :reduce="group => group.id"
                :clearable="false"
                size="sm"
                class="ps_select"
                disabled
            >
            </v-select>
          </b-col>
        </b-row>
        <b-row class="my-3">
          <b-col sm="3">
            <label for="bannerTitle" class="ps_label">{{label.pages.title}}</label>
          </b-col>
          <b-col sm="9">
            <b-form-input id="bannerTitle" size="sm" v-model="form.title"/>
          </b-col>
        </b-row>
        <b-row class="my-3">
          <b-col sm="3">
            <label for="bannerLink" class="ps_label">{{label.pages.description}}</label>
          </b-col>
          <b-col sm="9">
            <b-form-textarea id="bannerLink" size="sm" v-model="form.description"/>
          </b-col>
        </b-row>
        <b-row class="my-3">
          <b-col sm="3">
            <label for="sliderLink" class="ps_label"> {{label.pages.linkSlider}}</label>
          </b-col>
          <b-col sm="9">
            <b-form-input id="sliderLink" dir="ltr" size="sm" v-model="form.link"/>
          </b-col>
        </b-row>
        <b-row class="my-3">
          <b-col sm="3">
            <label for="priority" class="ps_label">{{label.pages.priority}}</label>
          </b-col>
          <b-col sm="9">
            <b-form-input id="priority" size="sm" type="number" v-model="form.priority"/>
          </b-col>
        </b-row>
        <b-row class="my-3">
          <b-col sm="3">
            <label for="priority" class="ps_label">
              {{label.pages.timeShow}}</label>
          </b-col>
          <b-col sm="9">
            <date-picker
                v-model="form.range"
                range
                clearable
                :min="time"
                color="#6AA435"
                display-format="jYYYY/jMM/jDD"
            />
          </b-col>
        </b-row>
        <b-row class="my-3">
          <b-col sm="12">
            <drop-zone-custom mode="image" :isRequired="true" :edit="true" :editSrc="form.imageAddress" />
          </b-col>
        </b-row>
        <b-row class="my-3">
          <b-col sm="3">
            <label for="bannerDisplay" class="ps_label">
              {{label.form.display}}
            </label>
          </b-col>
          <b-col sm="9">
            <label class="ps-switch">
              <input type="checkbox" v-model="form.isConfirm">
              <span class="slider round"></span>
            </label>
          </b-col>
        </b-row>
      </b-container>
      <template #modal-footer>
        <b-row class="w-100 justify-content-end">
          <b-col cols="auto" class="px-0">
            <b-button
                variant="ps-secondary"
                size="sm"
                class="mx-1"
                @click="editSliderModal=false"
            >
            {{label.buttons.cancel}}
            </b-button>
          </b-col>
          <b-col cols="auto" class="px-0">
            <b-button
                v-if="!loadingBtn"
                variant="ps-warning"
                size="sm"
                class="mx-1"
                @click="editSlider"
            >
            {{label.buttons.saveChanges}}
            </b-button>
            <b-button
                v-else
                variant="ps-warning"
                size="sm"
                class="mx-1"
                disabled
            >
              <b-spinner small></b-spinner>
            </b-button>
          </b-col>
        </b-row>
      </template>
    </b-modal>

    <!-- Delete Banner Confirm Modal -->
    <b-modal
        :dir="label.direction"
        v-model="delSliderModal"
        hide-header
        centered
    >
      <b-container fluid>
        <b-row>
          <p class="fs10 text-center lh1 mb-0">
            {{ label.captions.deleteConfirm}}
            <br/>
            <strong>« {{ delTitle }} »</strong>
          </p>
        </b-row>
      </b-container>
      <template #modal-footer>
        <b-row class="w-100 justify-content-end">
          <b-col cols="auto" class="px-0">
            <b-button
                variant="ps-secondary"
                size="sm"
                class="mx-1"
                @click="delSliderModal=false"
            >
            {{label.buttons.cancel}}
            </b-button>
          </b-col>
          <b-col cols="auto" class="px-0">
            <b-button
                v-if="!loadingBtn"
                variant="ps-danger"
                size="sm"
                class="mx-1"
                @click="deleteSlider"
            >
            {{label.buttons.deleteConfirm}}
            </b-button>
            <b-button
                v-else
                disabled
                variant="ps-danger"
                size="sm"
                class="mx-1"
            >
              <b-spinner small></b-spinner>
            </b-button>
          </b-col>
        </b-row>
      </template>
    </b-modal>
  </div>
</template>

<script>
import {mapGetters} from 'vuex'
import {dataGridMixin} from '@/components/dataGrid/dataGridMixin'
import moment from 'moment-jalaali'
import alert from '@/plugins/AlertMessages.js'
import dropZoneCustom from '@/components/DropZoneCustom'
import label from "@/plugins/StaticLabels.js";
import { contentLanguage } from "@/plugins/ContentLangMixin.js";

export default {
  name: "Sliders",
  mixins: [dataGridMixin, contentLanguage],
  components: {
    dropZoneCustom
  },
  data() {
    return {
      label,
      alert,
      time: moment().utc().format('jYYYY/jMM/jDD'),

      refreshImage: true,
      dropZoneAction: true,
      delId: null,
      delTitle: '',

      sliderFields: [
        {
          cellTemplate: 'radif',
          caption: label.table.row,
          allowSorting: false,
          allowFiltering: false,
          width: '100',
          cssClass: 'text-center align-middle'
        },
        {
          cellTemplate: 'actions',
          caption: label.table.actions,
          allowSorting: false,
          allowFiltering: false,
          width: '150',
          cssClass: 'text-center align-middle'
        },
        {
          cellTemplate: 'image',
          caption: label.table.image,
          allowSorting: false,
          allowFiltering: false,
          width: '150',
          cssClass: 'text-center align-middle'
        },
        {
          dataField: 'title',
          caption: label.table.title,
          dataType: 'string',
          cssClass: 'text-center align-middle fw2'
        },
        {
          dataField: 'link',
          caption: label.table.link,
          dataType: 'string',
          width: '200',
          cssClass: 'text-center align-middle'
        },
        {
          dataField: 'isConfirm',
          caption: label.table.status,
          dataType: 'boolean',
          cssClass: 'text-center align-middle'
        },
      ],
      addSliderModal: false,
      file: null,
      form: {
        title: null,
        description: null,
        link: null,
        priority: null,
        range: null,
        fromDateLocal: null,
        toDateLocal: null,
        isConfirm: true,
        imageName: '',
        imageAddress: null,
        fullPath: '',
      },
      editSliderModal: false,
      delSliderModal: false,
      imageLoad: false,
    }
  },
  computed: {
    ...mapGetters({
      postCheck: 'postCheck',
      sliders: 'baseX/sliders',
      loadingBtn: 'loadingBtn',
      imageUrl: 'imageUrl',
    }),
  },
  watch: {
    postCheck() {
      if (this.postCheck) {
        this.editModal = false;
        this.addSliderModal = false;
        this.editSliderModal = false;
        this.delSliderModal = false;
        this.imageLoad = false;
        this.reloadContent();
        this.reloadFields();
      }
    },
    imageUrl() {
      if (this.imageUrl && this.imageUrl.length > 0) {
        this.refreshImage = false
        this.dropZoneAction = false
        this.form.imageName = this.imageUrl[0].fullPath
        this.form.imageAddress = this.imageUrl[0].fileAddress
        this.$nextTick(() => {
          this.refreshImage = true
        });
        setTimeout(() => {
          this.$store.commit("setLoadingBtn", false);
        }, 800);
      }
    },
  },
  methods: {
    handleImageUpload(file) {
      this.file = file;
      this.$store.commit("setLoadingBtn", false);
    },
    add() {
      this.reloadFields();
      this.dropZoneAction = true;
      this.$store.commit("setUrlsEmpty");
      this.addSliderModal = true;
    },
    addSlider() {
      this.$store.commit("setLoadingBtn", true);
      let formData = new FormData();
      if (this.form.title != null) {
        formData.append('Title', this.form.title);
      }
      if (this.form.description != null) {
        formData.append('ShortDescription', this.form.description);
      }
      if (this.form.link != null) {
        if (this.form.link.indexOf("/") === 0 || this.form.link.indexOf("https") === 0 || this.form.link.indexOf("http") === 0 || this.form.link.indexOf("") === 0) {
          formData.append('Link', this.form.link);
        } else if (this.form.link.indexOf("/") !== 0) {
          formData.append('Link', "/" + this.form.link);
        }
      }
      if (this.form.imageName != null) {
        formData.append('ImageName', this.form.imageName);
      }
      if (this.form.priority != null) {
        formData.append('Priority', this.form.priority);
      }
      if (this.form.range != null && this.form.range !== undefined) {
        formData.append('FromDateLocal', this.form.range[0]);
        formData.append('ToDateLocal', this.form.range[1]);
      }
      formData.append('IsConfirm', this.form.isConfirm);
      formData.append('languageId', this.selectedLanguage);
      if(this.form.imageName != null) {
        this.$store.dispatch('baseX/addSlider', formData);
        this.dropZoneAction = true
      } else {
        this.$store.commit("setLoadingBtn", false);
        this.$store.commit('setError', alert.error.empty)
      }
    },
    edit(item) {
      this.editId = item.data.id;
      this.form = {
        title: item.data.title,
        description: item.data.shortDescription,
        link: item.data.link,
        priority: item.data.priority,
        isConfirm: item.data.isConfirm,
        imageName: item.data.imageName,
        imageAddress: item.data.imageAddress,
        fullPath: item.data.imageName,
      };
      if (item.data.fromDateLocal && item.data.toDateLocal && item.data.fromDateLocal != "" && item.data.toDateLocal != "") {
        this.form.range = [item.data.fromDateLocal , item.data.toDateLocal];
      } else {
        this.form.range = "";
      }
      this.editSliderModal = true;
    },
    editSlider() {
      this.$store.commit("setLoadingBtn", true);
      let formData = new FormData();
      if (this.form.title != null) {
        formData.append('Title', this.form.title);
      }
      if (this.form.description != null) {
        formData.append('ShortDescription', this.form.description);
      }
      if (this.form.link != null) {
        if (this.form.link.indexOf("/") === 0 || this.form.link.indexOf("https") === 0 || this.form.link.indexOf("http") === 0 || this.form.link.indexOf("") === 0) {
          formData.append('Link', this.form.link);
        } else if (this.form.link.indexOf("/") !== 0) {
          formData.append('Link', "/" + this.form.link);
        }
      }
      if (this.form.imageName != null) {
        formData.append('ImageName', this.form.imageName);
      }
      if (this.form.priority != null) {
        formData.append('Priority', this.form.priority);
      }
      if (this.form.range != null) {
        formData.append('FromDateLocal', this.form.range[0]);
        formData.append('ToDateLocal', this.form.range[1]);
      }
      formData.append('IsConfirm', this.form.isConfirm);
      formData.append('languageId', this.selectedLanguage);
      const values = {
        id: this.editId,
        value: formData
      };
      this.$store.dispatch('baseX/editSlider', values);
    },
    del(item) {
      this.delId = item.data.id;
      this.delTitle = item.data.title;
      this.delSliderModal = true;
    },
    deleteSlider() {
      this.$store.commit("setLoadingBtn", true);
      this.$store.dispatch('baseX/deleteSlider', this.delId);
    },
    reloadFields() {
      this.form = {
        title: null,
        description: null,
        link: null,
        priority: null,
        fromDateLocal: null,
        toDateLocal: null,
        isConfirm: true,
        imageName: '',
        imageAddress: null,
      };
      this.file = null;
      this.$store.commit("setLoadingBtn", false);
    },
    reloadContent() {
      this.$store.dispatch('baseX/getSliders', this.selectedLanguage);
    },
  },
  mounted() {
    this.reloadContent();
  },
}
</script>
